import React, { useState, useEffect } from 'react'
import { Menu } from 'antd'
import type { MenuProps } from 'antd'
import { useHistory, useLocation } from 'react-router-dom'
import { MenuContainer } from './styles'

const CompactMenu: React.FC = () => {
  const navigation = useHistory()
  const location = useLocation()
  const [current, setCurrent] = useState<string>('')

  // 현재 경로에 따른 메뉴 활성화
  useEffect(() => {
    const path = location.pathname
    if (path.includes('/users')) {
      setCurrent('1')
    } else if (path.includes('/usergroup')) {
      setCurrent('11')
    } else if (path.includes('/coin')) {
      setCurrent('2')
    } else if (path.includes('/position')) {
      setCurrent('3')
    } else if (path.includes('/record')) {
      setCurrent('4')
    } else if (path.includes('/balance')) {
      setCurrent('44')
    } else if (path.includes('/cash')) {
      setCurrent('51')
    } else if (path.includes('/ticket')) {
      setCurrent('66')
    } else if (path.includes('/events')) {
      setCurrent('6')
    } else if (path.includes('/system')) {
      setCurrent('7')
    }
  }, [location.pathname])

  const onClick: MenuProps['onClick'] = e => {
    setCurrent(e.key)

    // 메인 메뉴 클릭 시 첫 번째 서브메뉴로 이동
    const mainMenuKeys = ['1', '11', '2', '3', '4', '44', '51', '66', '6', '7']
    if (mainMenuKeys.includes(e.key)) {
      handleMainMenuClick(e.key)
    }
  }

  // 메인 메뉴 클릭 핸들러
  const handleMainMenuClick = (key: string) => {
    const menuRoutes: { [key: string]: string } = {
      '1': '/users',           // 회원관리 -> 전체회원
      '11': '/usergroup',      // 그룹관리
      '2': '/coin/coingroup',  // 종목운영 -> 장운영현황
      '3': '/position/open',   // 포지션관리 -> 활성 포지션
      '4': '/record/transaction-details', // 이력조회 -> 거래내역
      '44': '/balance/all',    // 정산관리 -> 정산현황
      '51': '/cash/deposit',   // 현금입출금 -> 입금관리
      '66': '/ticket',         // 사용자문의 -> 전체문의
      '6': '/events/announcements', // 공지/이벤트 -> 공지관리
      '7': '/system/1',        // 시스템 -> 거래소설정
    }

    if (menuRoutes[key]) {
      navigation.push(menuRoutes[key])
    }
  }

  const menuItems = [
    {
      key: '1',
      label: '회원관리',
      onTitleClick: () => navigation.push('/users'),
      children: [
        {
          label: '전체회원',
          key: '1-1',
          onClick: () => navigation.push('/users'),
        },
        {
          label: '거절회원',
          key: '1-21',
          onClick: () => navigation.push('/users/-2'),
        },
        {
          label: '신규회원',
          key: '1-2',
          onClick: () => navigation.push('/users/1'),
        },
        {
          label: '대기회원',
          key: '1-22',
          onClick: () => navigation.push('/users/-1'),
        },
        {
          label: '활동회원',
          key: '1-3',
          onClick: () => navigation.push('/users/2'),
        },
        {
          label: '블랙회원',
          key: '1-4',
          onClick: () => navigation.push('/users/3'),
        },
        {
          label: '모투회원',
          key: '1-5',
          onClick: () => navigation.push('/users/4'),
        },
        {
          label: '파트너회원',
          key: '1-7',
          onClick: () => navigation.push('/users/7'),
        },
        {
          label: '등급 및 수수료',
          key: '1-6',
          onClick: () => navigation.push('/users/5'),
        },
        {
          label: '레퍼럴 관리',
          key: '1-8',
          onClick: () => navigation.push('/users/6'),
        },
      ],
    },
    {
      key: '11',
      label: '그룹관리',
      onTitleClick: () => navigation.push('/usergroup'),
      children: [
        {
          label: '그룹목록',
          key: '11-1',
          onClick: () => navigation.push('/usergroup'),
        },
      ],
    },
    {
      key: '2',
      label: '종목운영',
      onTitleClick: () => navigation.push('/coin/coingroup'),
      children: [
        {
          label: '장운영현황',
          key: '2-1',
          onClick: () => navigation.push('/coin/coingroup'),
        },
        {
          label: '해선 종목 관리',
          key: '2-3',
          onClick: () => navigation.push('/coin/pair'),
        },
        {
          label: '시세관리',
          key: '2-4',
          onClick: () => navigation.push('/coin/price'),
        },
        {
          label: '실시간 시세',
          key: '2-5',
          onClick: () => navigation.push('/coin/market'),
        },
      ],
    },
    {
      key: '3',
      label: '포지션관리',
      onTitleClick: () => navigation.push('/position/open'),
      children: [
        {
          label: '활성 포지션',
          key: '3-1',
          onClick: () => navigation.push('/position/open'),
        },
        {
          label: '완료 포지션',
          key: '3-4',
          onClick: () => navigation.push('/position/closed'),
        },
        {
          label: '청산 포지션',
          key: '3-2',
          onClick: () => navigation.push('/position/liquid'),
        },
        {
          label: '청산 근접 포지션',
          key: '3-3',
          onClick: () => navigation.push('/position/liquid-near'),
        },
      ],
    },
    {
      key: '4',
      label: '이력조회',
      onTitleClick: () => navigation.push('/record/transaction-details'),
      children: [
        {
          label: '거래내역',
          key: '4-1',
          onClick: () => navigation.push('/record/transaction-details'),
        },
        {
          label: '활동이력',
          key: '4-2',
          onClick: () => navigation.push('/record/activity-history'),
        },
        {
          label: '계좌이력',
          key: '4-3',
          onClick: () => navigation.push('/record/wallet-history'),
        },
        {
          label: '계좌목록',
          key: '4-4',
          onClick: () => navigation.push('/record/wallet-list'),
        },
        {
          label: '아이피목록',
          key: '4-5',
          onClick: () => navigation.push('/record/ip-list'),
        },
      ],
    },
    {
      key: '44',
      label: '정산관리',
      onTitleClick: () => navigation.push('/balance/all'),
      children: [
        {
          label: '정산현황',
          key: '44-1',
          onClick: () => navigation.push('/balance/all'),
        },
        {
          label: '그룹별정산현황',
          key: '44-2',
          onClick: () => navigation.push('/balance/group'),
        },
        {
          label: '일별정산',
          key: '44-3',
          onClick: () => navigation.push('/balance/daily'),
        },
      ],
    },
    {
      key: '51',
      label: '현금입출금',
      onTitleClick: () => navigation.push('/cash/deposit'),
      children: [
        {
          label: '입금관리',
          key: '51-1',
          onClick: () => navigation.push('/cash/deposit'),
        },
        {
          label: '출금관리',
          key: '51-2',
          onClick: () => navigation.push('/cash/withdrawal'),
        },
        {
          label: '별도입출금',
          key: '51-3',
          onClick: () => navigation.push('/cash/other'),
        },
        {
          label: 'PG입출금',
          key: '51-4',
          onClick: () => navigation.push('/cash/pg/deposit'),
        },
      ],
    },
    {
      key: '66',
      label: '사용자문의',
      onTitleClick: () => navigation.push('/ticket'),
      children: [
        {
          label: '전체문의',
          key: '66-0',
          onClick: () => navigation.push('/ticket'),
        },
        {
          label: '대기',
          key: '66-1',
          onClick: () => navigation.push('/ticket/0'),
        },
        {
          label: '검토',
          key: '66-2',
          onClick: () => navigation.push('/ticket/1'),
        },
        {
          label: '완료',
          key: '66-3',
          onClick: () => navigation.push('/ticket/2'),
        },
      ],
    },
    {
      key: '6',
      label: '공지/이벤트',
      onTitleClick: () => navigation.push('/events/announcements'),
      children: [
        {
          label: '공지관리',
          key: '6-1',
          onClick: () => navigation.push('/events/announcements'),
        },
        {
          label: '이벤트관리',
          key: '6-2',
          onClick: () => navigation.push('/events/event'),
        },
        {
          label: '휴면이벤트세팅',
          key: '6-3',
          onClick: () => navigation.push('/events/human-event'),
        },
      ],
    },
    {
      key: '7',
      label: '시스템',
      onTitleClick: () => navigation.push('/system/1'),
      children: [
        {
          label: '거래소설정',
          key: '7-1',
          onClick: () => navigation.push('/system/1'),
        },
        {
          label: '제한프로그램 설정',
          key: '7-5',
          onClick: () => navigation.push('/system/5'),
        },
        {
          label: 'IP차단',
          key: '7-2',
          onClick: () => navigation.push('/system/2'),
        },
        {
          label: '팝업설정',
          key: '7-3',
          onClick: () => navigation.push('/system/3'),
        },
        {
          label: '환율관리',
          key: '7-6',
          onClick: () => navigation.push('/system/6'),
        },
        {
          label: '강제슬리피지',
          key: '7-7',
          onClick: () => navigation.push('/system/7'),
        },
        {
          label: '관리자 PC등록',
          key: '7-4',
          onClick: () => navigation.push('/system/4'),
        },
      ],
    },
  ]

  return (
    <MenuContainer>
      <Menu
        theme="dark"
        onClick={onClick}
        selectedKeys={[current]}
        mode="horizontal"
        items={menuItems}
        overflowedIndicator={null}
      />
    </MenuContainer>
  )
}

export default React.memo(CompactMenu)